import { IMessagingService } from "../services";
import { Component } from "./component";

class VideoComponent extends Component {
    private id: string;
    private videoComponent: HTMLElement;

    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);

        //this can be run from the YT script or as part of startup, so guard against double runs
        if (componentEl.classList.contains('video-component-loaded')) {
            return;
        }

        this.videoComponent = componentEl;
        this.id = componentEl.dataset.id;
    }
}

export { VideoComponent };
